import { render } from "./CreateUnduhanView.vue?vue&type=template&id=4b7b8b8a"
import script from "./CreateUnduhanView.vue?vue&type=script&lang=js"
export * from "./CreateUnduhanView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__